// extracted by mini-css-extract-plugin
export var measureBox = "_92-0";